/* Rhoe One theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(re);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    qsa(root, '[data-gallery]').forEach(function (g) {
      if (g.__init) return; g.__init = true;
      var track = g.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = qsa(track, '.gallery__slide');
      var thumbs = qsa(g, '[data-thumb-index]');
      var current = g.querySelector('[data-gallery-current]');
      var idx = 0;

      function go(i, smooth) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        setActive(i);
      }
      function setActive(i) {
        idx = i;
        if (current) current.textContent = i + 1;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        var at = thumbs[i];
        if (at && at.parentNode) {
          var p = at.parentNode;
          var left = at.offsetLeft - p.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2;
          p.scrollTo({ left: left, behavior: 'smooth' });
        }
        slides.forEach(function (s, n) {
          if (n !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
        });
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== idx) setActive(i);
        }, 60);
      }, { passive: true });
      thumbs.forEach(function (th) {
        th.addEventListener('click', function () { go(parseInt(th.getAttribute('data-thumb-index'), 10)); });
      });
      var prev = g.querySelector('[data-gallery-prev]');
      var next = g.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(idx - 1);
        if (e.key === 'ArrowRight') go(idx + 1);
      });
      g.__goToMedia = function (mediaId) {
        for (var n = 0; n < slides.length; n++) {
          if (String(slides[n].getAttribute('data-media-id')) === String(mediaId)) { go(n); return; }
        }
      };
    });
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    qsa(root, '[data-product-root]').forEach(function (p) {
      if (p.__init) return; p.__init = true;
      var jsonEl = p.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var section = p.closest('.product-section') || p;
      var form = p.querySelector('form[action*="/cart/add"]');
      var idInput = p.querySelector('[data-variant-id]');
      var gallery = p.querySelector('[data-gallery]');
      var addBtn = p.querySelector('[data-add-button]');
      var addLabel = p.querySelector('[data-add-label]');
      var errorEl = p.querySelector('[data-form-error]');
      var invJsonEl = p.querySelector('[data-inventory-json]');
      var inventory = {};
      if (invJsonEl) { try { inventory = JSON.parse(invJsonEl.textContent); } catch (e) {} }
      var groups = qsa(p, '[data-option-index]');

      function selectedOptions() {
        return groups.map(function (g) {
          var sel = g.querySelector('[data-option-select]');
          if (sel) return sel.value;
          var r = g.querySelector('[data-option-radio]:checked');
          return r ? r.value : null;
        });
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
        });
      }
      function markAvailability(opts) {
        groups.forEach(function (g, gi) {
          qsa(g, '[data-option-radio]').forEach(function (input) {
            var test = opts.slice(); test[gi] = input.value;
            var v = findVariant(test);
            input.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function updateInventory(v) {
        var line = p.querySelector('[data-inventory-line]');
        if (!line || !v) return;
        var text = line.querySelector('[data-inventory-text]');
        var qty = inventory[String(v.id)];
        var threshold = parseInt(line.getAttribute('data-threshold'), 10) || 10;
        if (!v.available) { line.hidden = true; return; }
        line.hidden = false;
        if (typeof qty === 'number' && qty > 0 && qty < threshold) {
          text.textContent = line.getAttribute('data-template').replace('[count]', qty);
          line.classList.add('is-low');
        } else {
          text.textContent = line.getAttribute('data-in-text');
          line.classList.remove('is-low');
        }
      }
      function update() {
        var opts = selectedOptions();
        groups.forEach(function (g, i) {
          var lbl = g.querySelector('[data-option-value]');
          if (lbl) lbl.textContent = opts[i];
        });
        markAvailability(opts);
        var v = findVariant(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        var priceEl = p.querySelector('[data-price]');
        var compareEl = p.querySelector('[data-compare-price]');
        var saveEl = p.querySelector('[data-save-badge]');
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(v.compare_at_price); }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) {
            saveEl.textContent = saveEl.getAttribute('data-save-style') === 'amount'
              ? 'Save ' + formatMoney(v.compare_at_price - v.price)
              : 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          }
        }
        var stickyPrice = section.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addLabel.textContent = v.available ? addBtn.getAttribute('data-label') : 'Sold out';
        }
        updateInventory(v);
        if (v.featured_media && gallery && gallery.__goToMedia) gallery.__goToMedia(v.featured_media.id);
        if (document.body.classList.contains('template-product') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('change', update);
      });
      if (groups.length) {
        var opts0 = selectedOptions();
        markAvailability(opts0);
        updateInventory(findVariant(opts0));
      } else {
        updateInventory(product.variants[0]);
      }

      // Quantity
      qsa(p, '[data-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        q.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      });

      // Submit
      if (form) {
        form.addEventListener('submit', function (e) {
          if (T.cartType === 'page') return; // normal POST → cart page
          e.preventDefault();
          if (addBtn) addBtn.classList.add('is-loading');
          if (errorEl) errorEl.hidden = true;
          var fd = new FormData(form);
          if (T.cartType === 'drawer') fd.append('sections', 'cart-drawer');
          fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status && data.status !== 200) throw new Error(data.description || data.message || 'Could not add to cart');
              if (T.cartType === 'checkout') { window.location.href = '/checkout'; return; }
              if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
              refreshCount();
              openDrawer();
            })
            .catch(function (err) {
              if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
            })
            .finally(function () { if (addBtn) addBtn.classList.remove('is-loading'); });
        });
      }

      // Sticky add to cart
      var sticky = section.querySelector('[data-sticky-atc]');
      var mainAtc = p.querySelector('[data-main-atc]');
      if (sticky && mainAtc && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var show = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        });
        io.observe(mainAtc);
        var sb = sticky.querySelector('[data-sticky-button]');
        if (sb) sb.addEventListener('click', function () {
          if (groups.length) {
            mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () {
              if (form.requestSubmit && addBtn && !addBtn.disabled) form.requestSubmit(addBtn);
            }, 450);
          } else if (form.requestSubmit) {
            form.requestSubmit(addBtn);
          } else {
            form.submit();
          }
        });
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function openDrawer() {
    var d = drawer();
    if (!d || T.cartType !== 'drawer') return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  function renderDrawer(html) {
    var wasOpen = drawer() && drawer().classList.contains('is-open');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    var old = drawer();
    if (fresh && old) {
      old.innerHTML = fresh.innerHTML;
      if (wasOpen) old.classList.add('is-open');
    }
  }
  function refreshCount() {
    fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        qsa(document, '[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
      });
  }
  function changeLine(line, qty) {
    var d = drawer();
    if (d) d.classList.add('is-loading');
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10)), sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderDrawer(data.sections['cart-drawer']);
        refreshCount();
      })
      .finally(function () { var dd = drawer(); if (dd) dd.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && T.cartType === 'drawer' && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var lc = e.target.closest('[data-line-change]');
    if (lc) { changeLine(lc.getAttribute('data-line-change'), lc.getAttribute('data-qty')); return; }
    var od = e.target.closest('[data-open-dialog]');
    if (od) {
      var dlg = document.getElementById(od.getAttribute('data-open-dialog'));
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-close-dialog]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Close mobile menu when a link is tapped
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.menu-drawer a');
    if (a) { var d = a.closest('details'); if (d) d.removeAttribute('open'); }
  });

  function init(root) { initGallery(root); initProduct(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
